// TrackCode validator: only A-Z / a-z, digits, dash; length 5-20
export const validateTrackCode = (code: string) => /^[A-Za-z0-9-]{5,20}$/.test(code)

/** TezId rule mirror of BACKEND/src/core/tezid/tezid.ts — keep identical. */
export const VALID_PREFIXES = [
	'TOS', 'TIV', 'AND', 'FAR', 'NMG', 'SIR', 'JIZ', 'SAM',
	'NAV', 'BUX', 'XIV', 'QAS', 'XON', 'NUK', 'TEZ', 'HOX', 'DEN',
] as const

export const TEZ_ID_REGEX = new RegExp(
	`^(${VALID_PREFIXES.join('|')})-?\\d{1,5}(-\\d{1,5})?$`,
)

export function canonicalizeTezId(raw: string): string {
	return raw.trim().toUpperCase().replace(/-/g, '')
}

export function isValidTezId(raw: string): boolean {
	return TEZ_ID_REGEX.test(raw.trim().toUpperCase())
}
